<button
  class="row-menu-button"
  [class.row-menu-button-in-header]="inHeader()"
  [matMenuTriggerFor]="menu"
  (click)="$event.stopPropagation()"
  [disabled]="loading()"
>
  @if (loading()) {
    <oph-loading [diameter]="18"></oph-loading>
  } @else {
    <img src="assets/img/icons/ellipsis.svg" alt="Menu" class="menu-icon" />
  }
</button>

<mat-menu #menu="matMenu" class="oph-select-menu">
  @for (option of menuOptions(); track option.action) {
    <button class="oph-select-menu-item" (click)="onAction(option)">
      <span>{{ option.label }}</span>
      <img [src]="option.icon" alt="" />
    </button>
  }
</mat-menu>
